const coinsHistoricalData = [{
  id: 'btc',
  name: 'bitcoin',
  historicData: [
    {
      year: 2011,
      monthPrices: [
        { monthId: 1, price: 0.3 },
        { monthId: 2, price: 0.7 },
        { monthId: 3, price: 0.92 },
        { monthId: 4, price: 0.77 },
        { monthId: 5, price: 3.03 },
        { monthId: 6, price: 9.57 },
        { monthId: 7, price: 15.4 },
        { monthId: 8, price: 13.09 },
        { monthId: 9, price: 8.21 },
        { monthId: 10, price: 5.03 },
        { monthId: 11, price: 3.15 },
        { monthId: 12, price: 3.06 },
      ],
    }, {
      year: 2012,
      monthPrices: [
        { monthId: 1, price: 5.27 },
        { monthId: 2, price: 6.08 },
        { monthId: 3, price: 4.92 },
        { monthId: 4, price: 4.83 },
        { monthId: 5, price: 5 },
        { monthId: 6, price: 5.27 },
        { monthId: 7, price: 6.63 },
        { monthId: 8, price: 9.55 },
        { monthId: 9, price: 9.97 },
        { monthId: 10, price: 12.40 },
        { monthId: 11, price: 10.57 },
        { monthId: 12, price: 12.56 },
      ],
    }, {
      year: 2013,
      monthPrices: [
        { monthId: 1, price: 13.30 },
        { monthId: 2, price: 20.5 },
        { monthId: 3, price: 34.5 },
        { monthId: 4, price: 104 },
        { monthId: 5, price: 116.38 },
        { monthId: 6, price: 129.3 },
        { monthId: 7, price: 84 },
        { monthId: 8, price: 96 },
        { monthId: 9, price: 128.26 },
        { monthId: 10, price: 125.49 },
        { monthId: 11, price: 198.51 },
        { monthId: 12, price: 946.92 },
      ],
    }, {
      year: 2014,
      monthPrices: [
        { monthId: 1, price: 770.4 },
        { monthId: 2, price: 853.4 },
        { monthId: 3, price: 563.74 },
        { monthId: 4, price: 478.2 },
        { monthId: 5, price: 456.27 },
        { monthId: 6, price: 629.02 },
        { monthId: 7, price: 635.59 },
        { monthId: 8, price: 595.08 },
        { monthId: 9, price: 474.13 },
        { monthId: 10, price: 381.33 },
        { monthId: 11, price: 325.39 },
        { monthId: 12, price: 378.64 },
      ],
    }, {
      year: 2015,
      monthPrices: [
        { monthId: 1, price: 313.92 },
        { monthId: 2, price: 226.40 },
        { monthId: 3, price: 258.74 },
        { monthId: 4, price: 246.55 },
        { monthId: 5, price: 232.12 },
        { monthId: 6, price: 223.31 },
        { monthId: 7, price: 257.66 },
        { monthId: 8, price: 280.04 },
        { monthId: 9, price: 227.35 },
        { monthId: 10, price: 237.57 },
        { monthId: 11, price: 325.08 },
        { monthId: 12, price: 362.73 },
      ],
    }, {
      year: 2016,
      monthPrices: [
        { monthId: 1, price: 455.93 },
        { monthId: 2, price: 439.84 },
        { monthId: 3, price: 436.22 },
        { monthId: 4, price: 466.05 },
        { monthId: 5, price: 536.65 },
        { monthId: 6, price: 756.88 },
        { monthId: 7, price: 688.5 },
        { monthId: 8, price: 628.26 },
        { monthId: 9, price: 628.77 },
        { monthId: 10, price: 720.40 },
        { monthId: 11, price: 749.1 },
        { monthId: 12, price: 969.3 },
      ],
    }, {
      year: 2017,
      monthPrices: [
        { monthId: 1, price: 1077.4 },
        { monthId: 2, price: 11085.01 },
        { monthId: 3, price: 1275.89 },
        { monthId: 4, price: 1336.9 },
        { monthId: 5, price: 2567.27 },
        { monthId: 6, price: 2899.97 },
        { monthId: 7, price: 2764 },
        { monthId: 8, price: 4369.98 },
        { monthId: 9, price: 4780.15 },
        { monthId: 10, price: 6121.9 },
        { monthId: 11, price: 10623 },
        { monthId: 12, price: 19498.63 },
      ],
    }, {
      year: 2018,
      monthPrices: [
        { monthId: 1, price: 17163 },
        { monthId: 2, price: 16985 },
        { monthId: 3, price: 11341 },
      ],
    }],
}, {
  id: 'eth',
  name: 'ethereum',
  historicData: [{
    year: 2014,
    monthPrices: [
      { monthId: 10, price: 0.72 },
      { monthId: 11, price: 0.7 },
      { monthId: 12, price: 0.78 },
    ],
  }, {
    year: 2015,
    monthPrices: [
      { monthId: 1, price: 1.29 },
      { monthId: 2, price: 0.8 },
      { monthId: 3, price: 1.1 },
      { monthId: 4, price: 1.23 },
      { monthId: 5, price: 0.96 },
      { monthId: 6, price: 1.27 },
      { monthId: 7, price: 3.29 },
      { monthId: 8, price: 2.59 },
      { monthId: 9, price: 1.34 },
      { monthId: 10, price: 1.09 },
      { monthId: 11, price: 1.03 },
      { monthId: 12, price: 0.99 },
    ],
  }, {
    year: 2016,
    monthPrices: [
      { monthId: 1, price: 2.58 },
      { monthId: 2, price: 6.50 },
      { monthId: 3, price: 14.02 },
      { monthId: 4, price: 11.84 },
      { monthId: 5, price: 14.73 },
      { monthId: 6, price: 21.2 },
      { monthId: 7, price: 14.36 },
      { monthId: 8, price: 12.37 },
      { monthId: 9, price: 14.26 },
      { monthId: 10, price: 13.4 },
      { monthId: 11, price: 11.04 },
      { monthId: 12, price: 8.52 },
    ],
  }, {
    year: 2017,
    monthPrices: [
      { monthId: 1, price: 10.54 },
      { monthId: 2, price: 15.22 },
      { monthId: 3, price: 52.57 },
      { monthId: 4, price: 75.76 },
      { monthId: 5, price: 196.97 },
      { monthId: 6, price: 388.11 },
      { monthId: 7, price: 284.45 },
      { monthId: 8, price: 378.89 },
      { monthId: 9, price: 373.7 },
      { monthId: 10, price: 336.46 },
      { monthId: 11, price: 478.47 },
      { monthId: 12, price: 824.24 },
    ],
  }, {
    year: 2018,
    monthPrices: [
      { monthId: 1, price: 1339.73 },
      { monthId: 2, price: 956.51 },
      { monthId: 3, price: 866.30 },
    ],
  }],
}];

export default coinsHistoricalData;
